import { useTranslation } from 'react-i18next';
import { FaCheck } from 'react-icons/fa';

import styles from './AuthTimeline.module.css';

interface AuthTimelineProps {
    currentStep: number;
    /** Parcours v2 (test A/B, utils/signupFlow) : l'étape 3 s'appelle « Essai gratuit » au lieu de « Paiement ». */
    trialLabel?: boolean;
}

export function AuthTimeline({ currentStep, trialLabel }: AuthTimelineProps) {
    const { t } = useTranslation();
    const stepKeys = [
        'global.timeline.signup',
        'global.timeline.infos',
        trialLabel ? 'global.timeline.trial' : 'global.timeline.payment',
        'global.timeline.done',
    ];

    return (
        <div className={styles.timeline}>
            {stepKeys.map((key, index) => {
                const isCompleted = index < currentStep;
                const isActive = index === currentStep;
                const isPending = index > currentStep;

                return (
                    <div key={key} className={styles.step}>
                        <div className={styles.iconRow}>
                            {index > 0 && (
                                <div className={`${styles.line} ${index <= currentStep ? styles.lineCompleted : ''}`} />
                            )}
                            <div
                                className={`${styles.icon} ${
                                    isCompleted
                                        ? styles.iconCompleted
                                        : isActive
                                          ? styles.iconActive
                                          : styles.iconPending
                                }`}
                            >
                                {isCompleted && <FaCheck size={14} />}
                            </div>
                            {index < stepKeys.length - 1 && (
                                <div className={`${styles.line} ${index < currentStep ? styles.lineCompleted : ''}`} />
                            )}
                        </div>
                        <span
                            className={[
                                styles.label,
                                isPending && styles.labelPending,
                                index === 0 && styles.labelFirst,
                                index === stepKeys.length - 1 && styles.labelLast,
                            ]
                                .filter(Boolean)
                                .join(' ')}
                        >
                            {t(key)}
                        </span>
                    </div>
                );
            })}
        </div>
    );
}
